class Api {
    constructor() {
        this.url = '';
    }

    setUrl(url) {
        this.url = url;
    }

    request(action, data = {}) {
        return FM.promiseRequest({
            method: 'POST',
            url: this.url,
            data: {
                ...data,
                action: action,
                ajax: 'Y'
            }
        })
    }

    getDocsAgreement(data) {
        return this.request('docs-agreement', data)
    }

    getOrgInfo(data) {
        return this.request('get-org-info', data);
    }

    getCertStamp(data) {
        return this.request('cert-stamp', data)
    }

    checkUserExists(data) {
        return this.request('check-user-exists', data)
    }

    
}

export default Api;